
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.468 43c-.217 0-.433-.038-.645-.123a1.84 1.84 0 01-1.157-1.73V30.224l-3.979-4.432a1.893 1.893 0 01-.29-2.076l2.969-6.199-8.879-2.854a1.798 1.798 0 01-.834-.57L7.665 8.049a1.877 1.877 0 01-.263-1.975A1.776 1.776 0 019.03 5h8.51c.99 0 1.797.831 1.797 1.853v3.49l4.13 4.086 10.524 1.206c.53.062 1.005.361 1.3.817l5.177 8.085a1.895 1.895 0 01-.161 2.251l-13.502 15.59c-.35.404-.835.622-1.337.622zm-4.269-18.492l3.95 4.394c.31.342.48.788.48 1.259V40.72l13.143-15.171L33.7 17.63l-9.528-1.092a.9.9 0 01.069.152 1.89 1.89 0 01-.042 1.548l-3 6.27zm-7.09-11.751l7.169 2.303-3.347-3.31a1.894 1.894 0 01-.553-1.335V7.014H9.375l4.735 5.743z","fill":"#88C0B3"}})])
          )
        }
      }
    